import { useState, useEffect } from 'react';

// Custom hook for loading user groups
export const useUserGroups = () => {
  const [userGroups, setUserGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadUserGroups = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${process.env.PUBLIC_URL}/data/usergroups.json`);
        if (!response.ok) {
          throw new Error('Failed to load user groups');
        }
        const data = await response.json();
        setUserGroups(data.usergroups || []);
      } catch (err) {
        setError(err.message);
        console.error('Error loading user groups:', err);
      } finally {
        setLoading(false);
      }
    };

    loadUserGroups();
  }, []);

  return { userGroups, loading, error };
};

// Custom hook for loading organizers
export const useOrganizers = () => {
  const [organizersData, setOrganizersData] = useState({
    organizers: [],
    eventOrganizers: [],
    awsHelpers: [],
    awsStaff: [],
    volunteersTeam: null,
    volunteers: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadOrganizers = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${process.env.PUBLIC_URL}/data/organizers.json`);
        if (!response.ok) {
          throw new Error('Failed to load organizers');
        }
        const data = await response.json();
        setOrganizersData({
          organizers: data.organizers || [],
          eventOrganizers: data.eventOrganizers || [],
          awsHelpers: data.awsHelpers || [],
          awsStaff: data.awsStaff || [],
          volunteersTeam: data.volunteersTeam || null,
          volunteers: data.volunteers || []
        });
      } catch (err) {
        setError(err.message);
        console.error('Error loading organizers:', err);
      } finally {
        setLoading(false);
      }
    };

    loadOrganizers();
  }, []);

  return { organizersData, loading, error };
};